import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import {
  useCreateEmployee,
  useDepartmentOptions,
  useRoleOptions, 
} from "../hooks";
import { EmployeeForm } from "../components/EmployeeForm";
import { PageLoader } from "#/components/common/PageLoader";

export default function EmployeeCreatePage() {
  const navigate = useNavigate();

  const createMutation = useCreateEmployee();
  const departmentsQuery = useDepartmentOptions();
  const rolesQuery = useRoleOptions(); // ✅ ADD

  const loading =
    departmentsQuery.isLoading || rolesQuery.isLoading;

  if (loading) {
    return <PageLoader label="Loading employee form..." />;
  }

  return (
    <div className="space-y-6">
      <div>
        <Link
          to="/employees"
          className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:underline"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to employees
        </Link>

        <h1 className="mt-3 text-2xl font-bold text-slate-900">
          Create employee
        </h1>
      </div>

      <EmployeeForm
        departments={departmentsQuery.data ?? []}
        roles={rolesQuery.data ?? []} 
        loading={createMutation.isPending}
        onSubmit={(values) =>
          createMutation.mutate(values, {
            onSuccess: () => navigate("/employees"),
          })
        }
      />
    </div>
  );
}